// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__WUfMz","tab":"ProcedureTabs_tab__2s6R2"};